import { ScreenSizes } from '@interfaces/index';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();
  const subtitleColor = appTheme.loginPage.assets.subtitleColor;

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    divider: {
      height: 2,
      background: appTheme.mainColor,
      borderRadius: '4px',
      marginBottom: '10px',
    },
    subTitle: {
      fontWeight: 500,
      fontSize: 20,
      lineHeight: '30px',
      color: subtitleColor,
      marginBottom: '10px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: '16px',
        lineHeight: '22px',
      },
    },
    scheduledEventsCounter: {
      marginLeft: '4px',
    },
    noEvents: {
      background: '#F7F7F7',
      borderRadius: '16px',
      gap: 12,
      height: 112,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
  };
};
